import React, {useState} from "react";
import './Projects.scss';
import images from "../../constants/images";
import HoverReveal from "../../components/HoverReveal/HoverReveal";
function Projects() {

    return (
        <section id='projects'>
            <div className="projects-container">
                <div className="projects__header">
                    <div>
                        <h3>Selected Projects</h3>
                    </div>
                    <p>A piece of my favorite projects that I worked on</p>
                </div>
                <div className="projects__list">
                    <HoverReveal 
                    href="https://github.com/NicolaLino/Route-Navigator"
                    title="Route Navigator"
                    info="Python, AI, Shortest Path Algorithms"
                    imageSrc={images.image01}
                    projectNumber="/01"
                    />
                    <HoverReveal 
                    href="https://github.com/NicolaLino/Text-Message-Encryption-and-Decryption"
                    title="Encryption / Decryption"
                    info="Linux, Bash, Shell"
                    imageSrc={images.image02}
                    projectNumber="/02"
                    />
                    <HoverReveal
                    href="https://github.com/NicolaLino/Basic-HTTP-Socket-Server"
                    title="HTTP Socket Server"
                    info="Simple HTTP web server built using Sockets in python 3"
                    imageSrc={images.image03}
                    projectNumber="/03"
                    />
                    <HoverReveal
                    href="https://github.com/NicolaLino/mazerunner"
                    title="Micromouse Maze Solver"
                    info="Design and program small robot to solve a maze"
                    imageSrc={images.image04}
                    projectNumber="/04"
                    />
                </div>

            </div>
        </section>
    )
}

export default Projects;